import { GlobalConfig, I18n } from 'galarm-config'
import { DateTimeUtils, TaskManager } from 'galarm-shared'
import { NavigationUtils, UIUtils } from 'galarm-ps-api'

const CalendarUtilsWithExtras = (function () {
  const isLastSnoozeTimeInSnoozeDuration = function (
    lastSnoozeOn,
    lastSnoozeFor
  ) {
    const currDate = Date.now()
    if (!lastSnoozeOn || !lastSnoozeFor) {
      return false
    }
    return currDate - lastSnoozeOn < lastSnoozeFor
  }

  const onStopSnooze = function (calendarEventId, onClose) {
    TaskManager.addHttpsCloudTask('cancelSnoozeForCalendarEventAlarm', {
      uid: GlobalConfig.uid,
      calendarEventId
    })
    if (onClose) {
      onClose()
    }
  }

  const onSnoozeSelected = function (eventId, duration, onClose) {
    onSnoozeEventCore(eventId, duration)
    if (onClose) {
      onClose()
    }
  }

  const onDismissCalendarEventAlarm = function (eventId, onClose) {
    onDismissCalendarEventAlarmCore(eventId)
    if (onClose) {
      onClose()
    }
  }

  const onDismissCalendarEventAlarmCore = function (eventId) {
    TaskManager.addHttpsCloudTask('dismissCalendarEventAlarm', {
      uid: GlobalConfig.uid,
      calendarEventId: eventId
    })
  }

  const onSnoozeEventCore = function (eventId, duration) {
    TaskManager.addHttpsCloudTask('snoozeCalendarEventAlarm', {
      uid: GlobalConfig.uid,
      calendarEventId: eventId,
      snoozeTime: Date.now(),
      snoozeInterval: duration
    })
  }

  const getDisplayTextForDuration = function (duration) {
    const snoozeDate = DateTimeUtils.shaveSecondsFromDate(Date.now())
    const newDate = snoozeDate + duration
    return I18n.t('calendarWithSnoozeAt', {
      timeString: DateTimeUtils.isDateToday(newDate)
        ? DateTimeUtils.getLocalizedTimeAsString(newDate)
        : DateTimeUtils.getLocalizedDateTimeWoYearAsString(newDate)
    })
  }

  const onSnoozeEvent = function (
    eventId,
    snoozeInterval,
    onChooseSnoozeDuration,
    onClose
  ) {
    if (snoozeInterval === 0) {
      onChooseSnoozeDuration(eventId)
    } else {
      onSnoozeSelected(eventId, snoozeInterval, onClose)
    }
  }

  const handleSnooze = function (
    calendarEvent,
    onClose,
    onChooseSnoozeDuration
  ) {
    const lastSnoozeOn = calendarEvent?.lastSnoozeOn
    const lastSnoozeFor = calendarEvent?.lastSnoozeFor
    const eventInSnooze = isLastSnoozeTimeInSnoozeDuration(
      lastSnoozeOn,
      lastSnoozeFor
    )
    if (eventInSnooze) {
      const durationString = DateTimeUtils.getShortDurationTillDateAsString(
        (lastSnoozeOn || Date.now()) +
          (lastSnoozeFor || GlobalConfig.defaultSnoozeInterval)
      )
      NavigationUtils.showAlert(
        I18n.t('alreadySnoozing'),
        I18n.t('alarmAlreadyInSnooze', { durationString }),
        [
          {
            text: I18n.t('changeSnoozeDuration'),
            onPress: () => {
              UIUtils.showChooseSnoozeMenu(
                calendarEvent?.id,
                (eventId, duration) => {
                  onSnoozeEvent(
                    eventId,
                    duration,
                    onChooseSnoozeDuration,
                    onClose
                  )
                }
              )
            }
          },
          {
            text: I18n.t('stopSnooze'),
            onPress: () => onStopSnooze(calendarEvent?.id, onClose)
          },
          {
            text: I18n.t('ok'),
            onPress: () => onClose && onClose()
          }
        ]
      )
      return
    }
    UIUtils.showChooseSnoozeMenu(calendarEvent?.id, (eventId, duration) => {
      onSnoozeEvent(eventId, duration, onChooseSnoozeDuration, onClose)
    })
  }

  return {
    isLastSnoozeTimeInSnoozeDuration,
    onStopSnooze,
    onSnoozeSelected,
    onSnoozeEventCore,
    getDisplayTextForDuration,
    onSnoozeEvent,
    handleSnooze,
    onDismissCalendarEventAlarm
  }
})()

export default CalendarUtilsWithExtras
